import React from 'react'
import { Dropdown, DropdownItem, DropdownMenuPosition } from '@duik/it'
import TableRow from '../UI/TableRow'
import cls from '../styles/Header.scss'
import CloudUpload from '@material-ui/icons/CloudUploadOutlined'
import ListIcon from '@material-ui/icons/FormatListBulletedRounded'
import MoreIcon from '@material-ui/icons/MoreHoriz'
import ToolTip from '../UI/ToolTip'
import { ToolTipContainer, TwoLineItemClick, LeftSideColor } from '../UI/TableItem'

type Material = {
  _id: string
  materialName: string
  unit: string
  singleTruck?: number
  tandemTruck?: number
  triaxleTruck?: number
  endDumpTruck?: number
  tandemPonyTrailer?: number
  triPonyTrailer?: number
  threeAxleTransferTrailer?: number
  fourAxleTransferTrailer?: number
  quadTrailer?: number
  companyId: string
  delete: boolean
}

type Props = {
  materialsList: Material[]
  haul: {
    _id: string
    haulType: string
    haulId: string
    pickUpSite: {
      _id: string
      siteName: string
      company: string
      location: string
      city: string
      province: string
      coordinates: {
        lat: number
        lng: number
      }
      delete: boolean
    }
    dropOffSite: {
      _id: string
      siteName: string
      company: string
      location: string
      city: string
      province: string
      coordinates: {
        lat: number
        lng: number
      }
      delete: boolean
    }
    notes: string
    startDateTime: string
    endDateTime: string
    project: {
      _id: string
      projectName: string
      projectNumber: string
      officeAddress: string
      city: string
      province: {
        value: string
        label: string
      }
      active: boolean
      delete: boolean
    }
    material: string
    materials: string[]
    trucksRequired: string
    truckType: string
    volume: string
    poNumber: string
    siteContact: {
      _id: string
      firstName: string
      lastName: string
      email: string
      phoneNumber: string
      company: string
      title: string
      __v: number
      delete: string
    }
    superIntendant: {
      _id: string
      firstName: string
      lastName: string
      email: string
      phoneNumber: string
      company: string
      title: string
      delete: string
    }
    projectId: string
    delete: string
    companyName: string
    companyId: string
    brokerCompanyIds?: string[]
  }
  haulDetailModalToggle(_id: string): void
  uploadBackupModalToggle(_id: string): void
  history: {
    push: (path: string) => void
  }
  index: number
  companyId: string
}

const materialText = (props: Props) => {
  const { haul, materialsList } = props
  if (haul.materials) {
    return haul.materials.reduce((allMaterials: string, materialId: string, index: number) => {
      const nextMaterial = materialsList.find(mat => mat._id === materialId)
      return index === 0
        ? nextMaterial
          ? nextMaterial.materialName
          : ''
        : `${allMaterials} | ${nextMaterial ? nextMaterial.materialName : null}`
    }, '')
  }
  return haul.material
}

const HaulItem = (props: Props) => {
  const { haul, haulDetailModalToggle, uploadBackupModalToggle, history, index, companyId } = props
  const color = LeftSideColor(index)
  return (
    <TableRow key={haul._id} clickable>
      {/* <TwoLineItemClick
        color={color.color}
        onClick={() => haulDetailModalToggle(haul._id)}
        text={moment(haul.startDateTime).format('MMM DD')}
        subText={moment(haul.startDateTime).format('YYYY')}
        width="12"
      /> */}
      <TwoLineItemClick
        color={color.color}
        onClick={() => haulDetailModalToggle(haul._id)}
        text={haul.haulId}
        subText={haul.project.projectName}
        width="20"
      />
      <TwoLineItemClick
        onClick={() => haulDetailModalToggle(haul._id)}
        text={haul.companyId === companyId ? materialText(props) : haul.material}
        subText={haul.haulType}
        width="20"
      />
      <TwoLineItemClick
        onClick={() => haulDetailModalToggle(haul._id)}
        text={haul.pickUpSite.siteName}
        subText={haul.pickUpSite.city}
        width="20"
      />
      <TwoLineItemClick
        onClick={() => haulDetailModalToggle(haul._id)}
        text={haul.dropOffSite.siteName}
        subText={haul.dropOffSite.city}
        width="20"
      />
      <ToolTipContainer>
        <ToolTip title="Loads" idName="haulIcon">
          <ListIcon
            className="actionsIcon"
            onClick={() =>
              history.push(`/app/hauls/${haul.project.projectNumber}/loads/${haul.haulId}`)
            }
          />
        </ToolTip>
        {haul.companyId === companyId ? (
          <>
            <ToolTip title="Upload" idName="haulIcon">
              <form action="/action_page_binary.asp" method="post" encType="multipart/form-data">
                {/* <input type="file" onChange={fileChange} /> */}
                <CloudUpload
                  className="actionsIcon"
                  onClick={() => uploadBackupModalToggle(haul._id)}
                />
              </form>
            </ToolTip>
            <Dropdown
              id="haulIcon"
              className={cls.dropdownFilter}
              ButtonComponent={(props: any) => (
                <MoreIcon className="actionsIcon" onClick={props.handleToggle} />
              )}
              menuPosition={DropdownMenuPosition['bottom-left']}
              closeOnOptionClick
            >
              <DropdownItem onClick={() => haulDetailModalToggle(haul._id)}>View</DropdownItem>
              <DropdownItem onClick={() => console.log('delete')}>Delete</DropdownItem>
            </Dropdown>
          </>
        ) : null}
      </ToolTipContainer>
    </TableRow>
  )
}

export default HaulItem
